// extracted by mini-css-extract-plugin
module.exports = {"container":"VA-z","copyContainer":"WA-z"};